module.exports = __webpack_public_path__ + "img/7-blue-diamond.33215121.png";